import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import SEO from "@/components/SEO";
import { Target, SignIn } from "@phosphor-icons/react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await login(username.trim(), password);
      toast.success("Welcome back");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-neutral-950 text-white flex items-center justify-center px-4">
      <SEO title="Admin Login" description="Admin login" path="/admin/login" noindex />
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 rounded-full bg-red-600 flex items-center justify-center">
            <Target size={22} weight="fill" />
          </div>
          <div>
            <div className="font-heading font-black text-xl">JUWAI TEER</div>
            <div className="text-[10px] uppercase tracking-widest text-yellow-400 font-semibold">Admin Console</div>
          </div>
        </div>
        <form onSubmit={submit} className="bg-neutral-900 border border-neutral-800 rounded-2xl p-6 space-y-4">
          <div>
            <label className="text-xs font-semibold uppercase tracking-widest text-neutral-400">Username</label>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-1 w-full px-3 py-2.5 rounded-md bg-neutral-950 border border-neutral-800 focus:border-red-600 outline-none"
              data-testid="login-username"
              required
              autoFocus
            />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-widest text-neutral-400">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full px-3 py-2.5 rounded-md bg-neutral-950 border border-neutral-800 focus:border-red-600 outline-none"
              data-testid="login-password"
              required
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            className="w-full py-2.5 rounded-md bg-red-600 hover:bg-red-500 font-semibold flex items-center justify-center gap-2 disabled:opacity-60"
            data-testid="login-submit"
          >
            <SignIn size={16} weight="bold" /> {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
